// import axios from 'axios'
// import {useIntl} from 'react-intl'
// import {KTIcon} from '../../../helpers'


const SidebarFooter = () => {

  return (
    <>

    </>
  )
}

export { SidebarFooter }
